module.exports = __webpack_public_path__ + "static/img/item-6.a232b7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/item-6.png
// module id = 700t
// module chunks = 3